import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  Badge,
  Input,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { data, factorData } from "./data";
import "./DataCollectionView.scss";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { DatePicker } from "antd";
import AddIcon from "@mui/icons-material/Add";
import { bulkUploadService } from "../../../services/emissionService";
import {
  getSupplierEmissions,
  getTimePeriods,
  getYtdData,
  submitSupplierEmissions,
  updateEmissionData,
} from "../../../services/srmService";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { toastMessage } from "../../../helper";
import { useNavigate } from "react-router-dom";
import moment from "moment";
export default function DataCollectionView() {
  const [value, setValue] = useState("1");
  const [customerId, setCustomerId] = useState("");
  const [formData, setFormData] = useState(JSON.parse(JSON.stringify(data)));
  let [timePeriod, setTimePeriod] = useState({
    fromDate: moment().startOf("month").toISOString(),
    toDate: moment().endOf("month").toISOString(),
  });
  let [fetchYtdData, setFetchYtdData] = useState(0);
  const resetForm = () => {
    setFormData(JSON.parse(JSON.stringify(data)));
    setEmissionData(null);
  };
  const floatRegex = /^\d+(\.\d{0,2})?$/;
  const navigate = useNavigate();

  const [submittedTimePeriods, setSubmittedTimePeriods] = useState<any>([]);
  let ytdData: any[] = [];
  const handleTabChange = (event: React.SyntheticEvent, newValue: any) => {
    setValue(newValue);
  };
  const goToCustomerList = () => {
    navigate("/partners/customers/list");
  };
  const onTimePeriodChange = (e: any) => {
    let fromDate = e.$d.toISOString();
    let toDate = moment(new Date(fromDate)).endOf("month").toISOString();
    // let split = e.$d.toDateString().split(" ");
    setTimePeriod({ fromDate, toDate });
  };
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setCustomerId(searchParams.get("customer") || "");
    getYtdData(
      new Date(timePeriod.fromDate).getFullYear().toString(),
      company.id
    ).then((res) => {
      ytdData = res.data;
      res.data.forEach((record: any) => {
        if (!record.field_level.startsWith("assurance_children_0_children_A")) {
          let obj = getObjectFromPath(record.field_level);
          if (
            record.field_level == "environment_children_0_children_D_children_1"
          ) {
            //set carbon intensity
            let numerator = res.data.find(
              (item: any) =>
                item.field_level ==
                "environment_children_0_children_D_children_0"
            ).ytd;
            let denominator = res.data.find(
              (item: any) => item.field_level == "environment"
            ).ytd;
            obj["ytd"] = (numerator / denominator).toFixed(2);
          } else if (
            record.field_level == "environment_children_0_children_D_children_2"
          ) {
            //set energy intensity
            let numerator = res.data.find(
              (item: any) =>
                item.field_level ==
                "environment_children_0_children_C_children_2"
            ).ytd;
            let denominator =
              res.data.find((item: any) => item.field_level == "environment")
                .ytd || 1;
            obj["ytd"] = (numerator / denominator).toFixed(2);
          } else if (
            record.field_level == "environment_children_1_children_D_children_1"
          ) {
            //set water intensity
            let numerator = res.data.find(
              (item: any) =>
                item.field_level ==
                "environment_children_1_children_C_children_0"
            ).ytd;
            let denominator =
              res.data.find((item: any) => item.field_level == "environment")
                .ytd || 1;
            obj["ytd"] = (numerator / denominator).toFixed(2);
          } else if (
            record.field_level == "environment_children_2_children_D_children_1"
          ) {
            //set waste intensity
            let numerator = res.data.find(
              (item: any) =>
                item.field_level ==
                "environment_children_2_children_C_children_0"
            ).ytd;
            let denominator =
              res.data.find((item: any) => item.field_level == "environment")
                .ytd || 1;
            obj["ytd"] = (numerator / denominator).toFixed(2);
          } else {
            obj["ytd"] = record.ytd.toFixed(2);
          }
        }
      });
      setFormData({ ...formData });
    });
  }, [fetchYtdData]);

  let [emissionData, setEmissionData] = useState<any>(null);
  useEffect(() => {
    getTimePeriods(
      new Date(timePeriod.fromDate).getFullYear().toString(),
      company.id,
      Number(customerId)
    ).then((res) => {
      setSubmittedTimePeriods(
        res.data?.time_periods.map((e: any) => new Date(e).toISOString()) || []
      );
      let intervals = res.data?.time_periods || [];
      if (intervals.includes(timePeriod.fromDate)) {
        //fetch timeperiod data
        getSupplierEmissions(
          timePeriod.fromDate,
          company.id,
          Number(customerId),
          timePeriod.toDate
        ).then((emissionRes) => {
          console.log(emissionRes.data);
          setEmissionData(emissionRes.data);
          fillForm(emissionRes.data);
          setFetchYtdData(fetchYtdData + 1);
        });
      } else {
        resetForm();
        setFetchYtdData(fetchYtdData + 1);
      }
    });
  }, [timePeriod]);
  const fillForm = (fillData: any) => {
    fillData.transactions.forEach((item: any) => {
      let obj = getObjectFromPath(item.field_level);
      obj.value = item.value;
      obj.attachments = item.attachments;
      obj.comments = item.comments;
      obj.dataSource = item.data_source;
    });
    setFormData({ ...formData });
  };
  const submitData = () => {
    if (!formData.revenue[0].value) {
      toastMessage("Products Required", "error");
      return;
    }

    if (emissionData) {
      let product = emissionData.transactions.find(
        (item: any) => item.param === "products"
      );
      if (!product.value) {
        toastMessage("Products Required", "error");
        return;
      }
      emissionData.transactions.forEach((item: any) => {
        let obj = getObjectFromPath(item.field_level);
        item.value = obj.value;
        item.attachments = obj.attachments;
        item.comments = obj.comments;
        item.data_source = obj.dataSource;
      });
      updateEmissionData(emissionData).then((res) => {
        setEmissionData(null);
        toastMessage("Data updated successfully", "success");
        goToCustomerList();
      });
    } else {
      let finalData: any = {
        customer: customerId,
        fromDate: timePeriod.fromDate,
        toDate: timePeriod.toDate,
        transactions: [],
      };
      if (company.id) {
        finalData["company"] = company.id;
      }
      let levels = ["revenue", "environment", "health", "assurance"];
      levels.forEach((level) => {
        if (formData[level].param) {
          finalData.transactions.push({
            fieldLevel: `${level}`,
            fieldName: formData[level].param,
            uom: formData[level].uom,
            value: formData[level].value,
            dataSource: formData[level].dataSource,
            comments: formData[level].comments,
            attachments: formData[level].attachments,
          });
        }
        if (formData[level].children) {
          formData[level].children.forEach((element: any, index: number) => {
            Object.keys(element.children).forEach((key) => {
              element.children[key].children.forEach(
                (field: any, fieldIndex: number) => {
                  finalData.transactions.push({
                    fieldLevel: `${level}_children_${index}_children_${key}_children_${fieldIndex}`,
                    fieldName: field.param,
                    uom: field.uom,
                    value: field.value,
                    dataSource: field.dataSource,
                    comments: field.comments,
                    attachments: field.attachments,
                  });
                }
              );
            });
          });
        }
      });

      submitSupplierEmissions(finalData).then((res) => {
        toastMessage("Data added successfully", "success");
        goToCustomerList();
      });
    }
  };

  const handleFileUpload = (e: any, pathString: string) => {
    let obj = getObjectFromPath(pathString);
    const promiseList: any[] = [];
    Array.from(e.target.files).forEach((file: any) => {
      const uploadData = new FormData();
      uploadData.append("file", file);
      promiseList.push(
        new Promise((resolve, reject) => {
          bulkUploadService(uploadData).then((res) => {
            resolve({ url: res.data.Location });
          });
        })
      );
    });
    Promise.all(promiseList).then((values) => {
      console.log(values);
      obj["attachments"] = values;
      setFormData({ ...formData });
    });
  };

  const handleValueChange = (event: any, pathString: any) => {
    if (event.target.value && !floatRegex.test(event.target.value)) return;
    const obj = getObjectFromPath(pathString);
    if (
      pathString.startsWith("environment_children_0") ||
      pathString == "environment"
    ) {
      calculateSectionOne(event, pathString, obj);
    }
    if (
      pathString.startsWith("environment_children_1") ||
      pathString == "environment"
    ) {
      calculateSectionTwo(event, pathString, obj);
    }
    if (
      pathString.startsWith("environment_children_2") ||
      pathString == "environment"
    ) {
      calculateSectionThree(event, pathString, obj);
    }
    if (pathString.startsWith("health_children_0")) {
      calculateSectionFour(event, pathString, obj);
    }
    obj["ytd"] = (
      Number(obj["ytd"]) +
      Number(event.target.value) -
      Number(obj["value"])
    ).toFixed(2);
    obj["value"] = event.target.value;
    setFormData({ ...formData });
  };

  const calculateSectionFour = (event: any, pathString: any, obj: any) => {
    let ytd = obj["ytd"];
    let value = obj["value"];
    obj["ytd"] = (
      Number(
        ytdData.find((item) => item.field_level == pathString)?.["ytd"] || 0
      ) + Number(event.target.value)
    ).toFixed(2);
    obj["value"] = event.target.value;
    if (
      pathString == "health_children_0_children_A_children_0" ||
      pathString == "health_children_0_children_A_children_2"
    ) {
      formData["health"]["children"][0]["children"]["B"]["children"][0][
        "value"
      ] = (
        (Number(
          formData["health"]["children"][0]["children"]["A"]["children"][2][
            "value"
          ]
        ) *
          1000000) /
        Number(
          formData["health"]["children"][0]["children"]["A"]["children"][0][
            "value"
          ]
        )
      ).toFixed(2);
      formData["health"]["children"][0]["children"]["B"]["children"][0]["ytd"] =
        (
          (Number(
            formData["health"]["children"][0]["children"]["A"]["children"][2][
              "ytd"
            ]
          ) *
            1000000) /
          Number(
            formData["health"]["children"][0]["children"]["A"]["children"][0][
              "ytd"
            ]
          )
        ).toFixed(2);
    }
    if (pathString == "health_children_0_children_A_children_3") {
      formData["health"]["children"][0]["children"]["B"]["children"][1][
        "value"
      ] =
        formData["health"]["children"][0]["children"]["A"]["children"][3][
          "value"
        ];
      formData["health"]["children"][0]["children"]["B"]["children"][1]["ytd"] =
        formData["health"]["children"][0]["children"]["A"]["children"][3][
          "ytd"
        ];
    }
    obj["ytd"] = ytd;
    obj["value"] = value;
  };
  const calculateSectionThree = (event: any, pathString: any, obj: any) => {
    let paths = pathString.split("_");
    if (
      paths.length > 5 &&
      (paths[4] == "A" || paths[4] == "B") &&
      paths[6] != "0"
    ) {
      if (paths[4] == "A") {
        const c1 = Number(
          formData["environment"]["children"][2]["children"]["A"][
            "children"
          ][0]["value"]
        );
        formData["environment"]["children"][2]["children"]["A"]["children"][0][
          "value"
        ] = Math.abs(
          c1 + Number(event.target.value) - Number(obj.value)
        ).toFixed(2);
        formData["environment"]["children"][2]["children"]["A"]["children"][0][
          "ytd"
        ] =
          Number(
            ytdData.find(
              (item) =>
                item.field_level ==
                "environment_children_2_children_A_children_0"
            )?.ytd || 0
          ) +
          Number(
            formData["environment"]["children"][2]["children"]["A"][
              "children"
            ][0]["value"]
          );
      }
      if (paths[4] == "B") {
        const c2 = Number(
          formData["environment"]["children"][2]["children"]["B"][
            "children"
          ][0]["value"]
        );
        formData["environment"]["children"][2]["children"]["B"]["children"][0][
          "value"
        ] = Math.abs(
          c2 + Number(event.target.value) - Number(obj.value)
        ).toFixed(2);

        formData["environment"]["children"][2]["children"]["B"]["children"][0][
          "ytd"
        ] =
          Number(
            ytdData.find(
              (item) =>
                item.field_level ==
                "environment_children_2_children_B_children_0"
            )?.ytd || 0
          ) +
          Number(
            formData["environment"]["children"][2]["children"]["B"][
              "children"
            ][0]["value"]
          );
      }
      const c3 = Number(
        formData["environment"]["children"][2]["children"]["C"]["children"][0][
          "value"
        ]
      );
      formData["environment"]["children"][2]["children"]["C"]["children"][0][
        "value"
      ] = Math.abs(c3 + Number(event.target.value) - Number(obj.value)).toFixed(
        2
      );
      formData["environment"]["children"][2]["children"]["C"]["children"][0][
        "ytd"
      ] =
        Number(
          ytdData.find(
            (item) =>
              item.field_level == "environment_children_2_children_C_children_0"
          )?.ytd || 0
        ) +
        Number(
          formData["environment"]["children"][2]["children"]["C"][
            "children"
          ][0]["value"]
        );
      formData["environment"]["children"][2]["children"]["D"]["children"][0][
        "value"
      ] = (
        Number(
          formData["environment"]["children"][2]["children"]["C"][
            "children"
          ][0]["value"]
        ) / Number(formData["environment"]["value"])
      ).toFixed(2);
      formData["environment"]["children"][2]["children"]["D"]["children"][0][
        "ytd"
      ] = (
        Number(
          formData["environment"]["children"][2]["children"]["C"][
            "children"
          ][0]["ytd"]
        ) / Number(formData["environment"]["ytd"])
      ).toFixed(2);
    }
    if (pathString == "environment") {
      formData["environment"]["children"][2]["children"]["D"]["children"][0][
        "value"
      ] = (
        Number(
          formData["environment"]["children"][2]["children"]["C"][
            "children"
          ][0]["value"]
        ) / Number(event.target.value)
      ).toFixed(2);
      formData["environment"]["children"][2]["children"]["D"]["children"][0][
        "ytd"
      ] = (
        Number(
          formData["environment"]["children"][2]["children"]["C"][
            "children"
          ][0]["ytd"]
        ) /
        (Number(formData["environment"]["ytd"]) +
          Number(event.target.value) -
          Number(formData["environment"]["value"]))
      ).toFixed(2);
    }
  };

  const calculateSectionTwo = (event: any, pathString: any, obj: any) => {
    let paths = pathString.split("_");
    if ((paths.length > 5 && paths[4] == "A") || paths[4] == "B") {
      if (paths[4] == "A") {
        const c1 = Number(
          formData["environment"]["children"][1]["children"]["C"][
            "children"
          ][0]["value"]
        );
        formData["environment"]["children"][1]["children"]["C"]["children"][0][
          "value"
        ] = Math.abs(
          c1 + Number(event.target.value) - Number(obj.value)
        ).toFixed(2);
        formData["environment"]["children"][1]["children"]["C"]["children"][0][
          "ytd"
        ] = (
          Number(
            ytdData.find(
              (item) =>
                item.field_level ==
                "environment_children_1_children_C_children_0"
            )?.ytd || 0
          ) +
          Number(
            formData["environment"]["children"][1]["children"]["C"][
              "children"
            ][0]["value"]
          )
        ).toFixed(2);
      }
      if ((paths[4] == "B" && paths[6] == "1") || paths[4] == "A") {
        const c2 = Number(
          formData["environment"]["children"][1]["children"]["C"][
            "children"
          ][1]["value"]
        );
        formData["environment"]["children"][1]["children"]["C"]["children"][1][
          "value"
        ] = Math.abs(
          c2 + Number(event.target.value) - Number(obj.value)
        ).toFixed(2);
        formData["environment"]["children"][1]["children"]["C"]["children"][1][
          "ytd"
        ] = (
          Number(
            ytdData.find(
              (item) =>
                item.field_level ==
                "environment_children_1_children_C_children_1"
            )?.ytd || 0
          ) +
          Number(
            formData["environment"]["children"][1]["children"]["C"][
              "children"
            ][1]["value"]
          )
        ).toFixed(2);
      }
      formData["environment"]["children"][1]["children"]["D"]["children"][0][
        "value"
      ] = (
        Number(
          formData["environment"]["children"][1]["children"]["C"][
            "children"
          ][0]["value"]
        ) / Number(formData["environment"]["value"])
      ).toFixed(2);
      formData["environment"]["children"][1]["children"]["D"]["children"][0][
        "ytd"
      ] = (
        Number(
          formData["environment"]["children"][1]["children"]["C"][
            "children"
          ][0]["ytd"]
        ) / Number(formData["environment"]["ytd"])
      ).toFixed(2);
    }
    if (pathString == "environment") {
      formData["environment"]["children"][1]["children"]["D"]["children"][0][
        "value"
      ] = (
        Number(
          formData["environment"]["children"][1]["children"]["C"][
            "children"
          ][0]["value"]
        ) / Number(event.target.value)
      ).toFixed(2);
      formData["environment"]["children"][1]["children"]["D"]["children"][0][
        "ytd"
      ] = (
        Number(
          formData["environment"]["children"][1]["children"]["C"][
            "children"
          ][0]["ytd"]
        ) /
        (Number(formData["environment"]["ytd"]) +
          Number(event.target.value) -
          Number(formData["environment"]["value"]))
      ).toFixed(2);
    }
  };

  const calculateSectionOne = (event: any, pathString: any, obj: any) => {
    let paths = pathString.split("_");
    if ((paths.length > 5 && paths[4] == "A") || paths[4] == "B") {
      const c1 = Number(
        formData["environment"]["children"][0]["children"]["C"]["children"][2][
          "value"
        ]
      );
      formData["environment"]["children"][0]["children"]["C"]["children"][2][
        "value"
      ] = Math.abs(
        c1 +
          (Number(event.target.value) - Number(obj.value)) *
            Number(factorData[obj.param].energy)
      ).toFixed(2);
      formData["environment"]["children"][0]["children"]["C"]["children"][2][
        "ytd"
      ] = (
        Number(
          ytdData.find(
            (item) =>
              item.field_level ===
              "environment_children_0_children_C_children_children_2"
          )?.["ytd"] || 0
        ) +
        Number(
          formData["environment"]["children"][0]["children"]["C"][
            "children"
          ][2]["value"]
        )
      ).toFixed(2);
      if (paths[4] == "A") {
        const c2 = Number(
          formData["environment"]["children"][0]["children"]["C"][
            "children"
          ][0]["value"]
        );
        formData["environment"]["children"][0]["children"]["C"]["children"][0][
          "value"
        ] = Math.abs(
          c2 +
            (Number(event.target.value) - Number(obj.value)) *
              Number(factorData[obj.param].emission)
        ).toFixed(2);
        formData["environment"]["children"][0]["children"]["C"]["children"][0][
          "ytd"
        ] = (
          Number(
            ytdData.find(
              (item) =>
                item.field_level ==
                "environment_children_0_children_C_children_0"
            )?.["ytd"] || 0
          ) +
          Number(
            formData["environment"]["children"][0]["children"]["C"][
              "children"
            ][0]["value"]
          )
        ).toFixed(2);
      }
      if (paths[4] == "B") {
        const c3 = Number(
          formData["environment"]["children"][0]["children"]["C"][
            "children"
          ][1]["value"]
        );
        formData["environment"]["children"][0]["children"]["C"]["children"][1][
          "value"
        ] = Math.abs(
          c3 +
            (Number(event.target.value) - Number(obj.value)) *
              Number(factorData[obj.param].emission)
        ).toFixed(2);
        formData["environment"]["children"][0]["children"]["C"]["children"][1][
          "ytd"
        ] = (
          Number(
            ytdData.find(
              (item) =>
                item.field_level ==
                "environment_children_0_children_C_children_1"
            )?.["ytd"] || 0
          ) +
          Number(
            formData["environment"]["children"][0]["children"]["C"][
              "children"
            ][1]["value"]
          )
        ).toFixed(2);
      }
      formData["environment"]["children"][0]["children"]["D"]["children"][0][
        "value"
      ] = (
        Number(
          formData["environment"]["children"][0]["children"]["C"][
            "children"
          ][0]["value"]
        ) +
        Number(
          formData["environment"]["children"][0]["children"]["C"][
            "children"
          ][1]["value"]
        )
      ).toFixed(2);
      formData["environment"]["children"][0]["children"]["D"]["children"][0][
        "ytd"
      ] = (
        Number(
          formData["environment"]["children"][0]["children"]["C"][
            "children"
          ][0]["ytd"]
        ) +
        Number(
          formData["environment"]["children"][0]["children"]["C"][
            "children"
          ][1]["ytd"]
        )
      ).toFixed(2);
      formData["environment"]["children"][0]["children"]["D"]["children"][1][
        "value"
      ] = (
        Number(
          formData["environment"]["children"][0]["children"]["D"][
            "children"
          ][0]["value"]
        ) / Number(formData["environment"]["value"])
      ).toFixed(2);
      formData["environment"]["children"][0]["children"]["D"]["children"][1][
        "ytd"
      ] = (
        Number(
          formData["environment"]["children"][0]["children"]["D"][
            "children"
          ][0]["ytd"]
        ) / Number(formData["environment"]["ytd"])
      ).toFixed(2);
      formData["environment"]["children"][0]["children"]["D"]["children"][2][
        "value"
      ] = (
        Number(
          formData["environment"]["children"][0]["children"]["C"][
            "children"
          ][2]["value"]
        ) / Number(formData["environment"]["value"])
      ).toFixed(2);
      formData["environment"]["children"][0]["children"]["D"]["children"][2][
        "ytd"
      ] = (
        Number(
          formData["environment"]["children"][0]["children"]["C"][
            "children"
          ][2]["ytd"]
        ) / Number(formData["environment"]["ytd"])
      ).toFixed(2);
      // energy
    }
    if (pathString == "environment") {
      formData["environment"]["children"][0]["children"]["D"]["children"][1][
        "value"
      ] = (
        Number(
          formData["environment"]["children"][0]["children"]["D"][
            "children"
          ][0]["value"]
        ) / Number(event.target.value)
      ).toFixed(2);
      formData["environment"]["children"][0]["children"]["D"]["children"][1][
        "ytd"
      ] = (
        Number(
          formData["environment"]["children"][0]["children"]["D"][
            "children"
          ][0]["ytd"]
        ) /
        (Number(formData["environment"]["ytd"]) +
          Number(event.target.value) -
          Number(formData["environment"]["value"]))
      ).toFixed(2);
      formData["environment"]["children"][0]["children"]["D"]["children"][2][
        "value"
      ] = (
        Number(
          formData["environment"]["children"][0]["children"]["C"][
            "children"
          ][2]["value"]
        ) / Number(event.target.value)
      ).toFixed(2);
      formData["environment"]["children"][0]["children"]["D"]["children"][2][
        "ytd"
      ] = (
        Number(
          formData["environment"]["children"][0]["children"]["C"][
            "children"
          ][0]["ytd"]
        ) /
        (Number(formData["environment"]["ytd"]) +
          Number(event.target.value) -
          Number(formData["environment"]["value"]))
      ).toFixed(2);
      // energy
    }
  };

  const handleChange = (e: any, pathString: any, name: string) => {
    const obj = getObjectFromPath(pathString);
    obj[name] = e.target.value;
    setFormData({ ...formData });
  };
  const getObjectFromPath = (pathString: string) => {
    let paths = pathString.split("_");
    let obj = formData;
    for (let i of paths) {
      console.log(isNaN(Number(i)) ? i : Number(i));
      obj = obj[isNaN(Number(i)) ? i : Number(i)];
    }
    return obj;
  };

  const trigger = (e: any) => {
    setTimeout(() => {
      getTimePeriods(
        document.querySelector(".ant-picker-year-btn")?.innerHTML || "",
        company.id,
        Number(customerId)
      ).then((res) => {
        setSubmittedTimePeriods(
          res.data?.time_periods.map((e: any) => new Date(e).toISOString()) ||
            []
        );
      });
    }, 100);
  };
  return (
    <div className="pw-data-collection">
      <Box
        sx={{ padding: "25px", background: "#F6F7FA", marginBottom: "60px" }}
      >
        <div
          className="flex flex-row items-center"
          style={{ marginBottom: "10px" }}
        >
          <div style={{ marginRight: "10px" }}>
            <DatePicker
              allowClear={false}
              format={"MMM YYYY"}
              disabledDate={(d) => !d || d.isAfter(dayjs())}
              defaultValue={dayjs(
                new Date().toISOString().split("T")[0],
                "YYYY-MM-DD"
              )}
              superNextIcon={<ArrowForwardIosIcon onClick={trigger} />}
              superPrevIcon={<ArrowBackIosIcon onClick={trigger} />}
              cellRender={(current, { originNode }) => {
                return submittedTimePeriods.includes(
                  current.toDate().toDateString().split(" ")[1]
                ) ? (
                  originNode
                ) : (
                  <Badge color="info" variant="dot">
                    <span>{originNode}</span>
                  </Badge>
                );
              }}
              onChange={onTimePeriodChange}
              picker="month"
            />
          </div>
          <div>Amararaja Batteries</div>
        </div>

        <Box
          sx={{
            padding: "25px",
            borderRadius: "10px",
            marginBottom: "10px",
            backgroundColor: "white",
          }}
        >
          <div className="flex flex-row justify-between">
            <div className="flex flex-col basis-2/5">
              <label>
                Products supplied <span className="pw-mandatory-icon">*</span>
              </label>
              <OutlinedInput
                value={formData.revenue.children[0].value}
                onChange={(e) => {
                  handleChange(e, "revenue_children_0", "value");
                  // setProducts(e.target.value);
                }}
              />
            </div>
            <div className="flex flex-col basis-2/5">
              <label> % Turnover attributable to the customer</label>
              <OutlinedInput
                value={formData.revenue.children[1].value}
                onChange={(e) => {
                  if (floatRegex.test(e.target.value)) {
                    handleChange(e, "revenue_children_1", "value");
                  }
                }}
              />
            </div>
            <div></div>
          </div>
        </Box>
        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              width: "fit-content",
            }}
          >
            <TabList onChange={handleTabChange} className="pw-supplier-tabs">
              <Tab
                value="1"
                sx={{ fontWeight: value == "1" ? "bold" : "regular" }}
                label="Environment"
              />
              <Tab
                value="2"
                sx={{ fontWeight: value == "2" ? "bold" : "regular" }}
                label="Health and Safety"
              />
              <Tab
                value="3"
                sx={{ fontWeight: value == "3" ? "bold" : "regular" }}
                label="Positive assurance"
              />
            </TabList>
          </Box>
          <TabPanel value="1">
            <Table sx={{ minWidth: 650 }} className="pw-data-table">
              <TableHead sx={{ backgroundColor: "#FAFBFD" }}>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Parameters</TableCell>
                  <TableCell>UOM</TableCell>
                  <TableCell>Target</TableCell>
                  <TableCell>YTD</TableCell>
                  <TableCell>Data source</TableCell>
                  <TableCell>Value</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Comments</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>
                    <b>Total Production</b>
                  </TableCell>
                  <TableCell>MT</TableCell>
                  <TableCell>{formData.environment.target}</TableCell>
                  <TableCell>{formData.environment.ytd}</TableCell>
                  <TableCell>
                    <FormControl fullWidth variant="standard">
                      <Select
                        value={formData.environment.dataSource}
                        onChange={(e) =>
                          handleChange(e, "environment", "dataSource")
                        }
                      >
                        <MenuItem value={"SAP"}>SAP</MenuItem>
                        <MenuItem value={"Excel Logs"}>Excel Logs</MenuItem>
                        <MenuItem value={"Regisers"}>Regisers</MenuItem>
                        <MenuItem value={"Other"}>
                          Other (Specify in comments)
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#FDF8E8" }}>
                    {" "}
                    <Input
                      onChange={(e) => handleValueChange(e, "environment")}
                      value={formData.environment.value}
                    />{" "}
                  </TableCell>
                  <TableCell>
                    <label htmlFor="environment">
                      <Badge
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        className={
                          formData.environment.attachments.length
                            ? "pw-badge-primary"
                            : "pw-badge-disabled"
                        }
                        badgeContent={
                          formData.environment.attachments.length || <AddIcon />
                        }
                      >
                        <AttachFileIcon />
                      </Badge>
                    </label>
                    <input
                      multiple
                      className="hidden"
                      onChange={(e) => handleFileUpload(e, "environment")}
                      id="environment"
                      type="file"
                    />
                  </TableCell>
                  <TableCell>
                    <Input
                      onChange={(e) =>
                        handleChange(e, "environment", "comments")
                      }
                      value={formData.environment.comments}
                    />
                  </TableCell>
                </TableRow>
                {formData.environment.children.map(
                  (group: any, index: number) => {
                    return (
                      <>
                        {group.title ? (
                          <TableRow>
                            <TableCell>
                              <b style={{ fontSize: "1rem" }}>{index + 1}</b>
                            </TableCell>
                            <TableCell colSpan={8}>
                              <b style={{ fontSize: "1rem" }}>{group.title}</b>
                            </TableCell>
                          </TableRow>
                        ) : (
                          ""
                        )}
                        {Object.keys(group.children).map((key: string) => {
                          return (
                            <>
                              <TableRow>
                                <TableCell
                                  style={{
                                    fontSize: "0.95rem",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {key}
                                </TableCell>
                                <TableCell
                                  style={{
                                    fontSize: "0.95rem",
                                    fontWeight: "bold",
                                  }}
                                  colSpan={8}
                                >
                                  {group.children[key].title}
                                </TableCell>
                              </TableRow>
                              {group.children[key].children.map(
                                (row: any, rowIndex: any) => {
                                  return (
                                    <TableRow>
                                      <TableCell>{row.SNO}</TableCell>
                                      <TableCell>
                                        <div className="text-left">
                                          {row.param}
                                        </div>
                                      </TableCell>
                                      <TableCell>{row.uom}</TableCell>
                                      <TableCell>{row.target}</TableCell>
                                      <TableCell>{row.ytd}</TableCell>
                                      <TableCell>
                                        <FormControl
                                          fullWidth
                                          variant="standard"
                                        >
                                          <Select
                                            value={row.dataSource}
                                            onChange={(e) =>
                                              handleChange(
                                                e,
                                                `environment_children_${index}_children_${key}_children_${rowIndex}`,
                                                "dataSource"
                                              )
                                            }
                                          >
                                            <MenuItem value={"SAP"}>
                                              SAP
                                            </MenuItem>
                                            <MenuItem value={"Excel Logs"}>
                                              Excel Logs
                                            </MenuItem>
                                            <MenuItem value={"Regisers"}>
                                              Regisers
                                            </MenuItem>
                                            <MenuItem value={"Other"}>
                                              Other (Specify in comments)
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          backgroundColor:
                                            key != "C" &&
                                            key != "D" &&
                                            !(
                                              index == 2 &&
                                              (key == "A" || key == "B") &&
                                              rowIndex == 0
                                            )
                                              ? "#FDF8E8"
                                              : "#F3F6FB",
                                        }}
                                      >
                                        {key != "C" &&
                                        key != "D" &&
                                        !(
                                          index == 2 &&
                                          (key == "A" || key == "B") &&
                                          rowIndex == 0
                                        ) ? (
                                          <Input
                                            value={row.value}
                                            onChange={(e) =>
                                              handleValueChange(
                                                e,
                                                `environment_children_${index}_children_${key}_children_${rowIndex}`
                                              )
                                            }
                                          />
                                        ) : (
                                          <div>{row.value}</div>
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        <label
                                          htmlFor={`environment_children_${index}_children_${key}_children_${rowIndex}`}
                                        >
                                          <Badge
                                            anchorOrigin={{
                                              vertical: "bottom",
                                              horizontal: "right",
                                            }}
                                            className={
                                              row.attachments.length
                                                ? "pw-badge-primary"
                                                : "pw-badge-disabled"
                                            }
                                            badgeContent={
                                              row.attachments.length || (
                                                <AddIcon />
                                              )
                                            }
                                          >
                                            <AttachFileIcon />
                                          </Badge>
                                        </label>
                                        <input
                                          type="file"
                                          className="hidden"
                                          id={`environment_children_${index}_children_${key}_children_${rowIndex}`}
                                          onChange={(e) =>
                                            handleFileUpload(
                                              e,
                                              `environment_children_${index}_children_${key}_children_${rowIndex}`
                                            )
                                          }
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <Input
                                          onChange={(e) =>
                                            handleChange(
                                              e,
                                              `environment_children_${index}_children_${key}_children_${rowIndex}`,
                                              "comments"
                                            )
                                          }
                                          value={row.comments}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  );
                                }
                              )}
                            </>
                          );
                        })}
                      </>
                    );
                  }
                )}
              </TableBody>
            </Table>
          </TabPanel>
          <TabPanel value="2">
            <Table sx={{ minWidth: 650 }} className="pw-data-table">
              <TableHead sx={{ backgroundColor: "#FAFBFD" }}>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Parameters</TableCell>
                  <TableCell>UOM</TableCell>
                  <TableCell>Target</TableCell>
                  <TableCell>YTD</TableCell>
                  <TableCell>Data source</TableCell>
                  <TableCell>Value</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Comments</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {formData.health.children.map((group: any, index: any) => {
                  return (
                    <>
                      {group.title ? (
                        <TableRow>
                          <TableCell style={{ fontSize: "1rem" }}>
                            <b>{index + 1}</b>
                          </TableCell>
                          <TableCell colSpan={8} style={{ fontSize: "1rem" }}>
                            <b>{group.title}</b>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                      {Object.keys(group.children).map((key: string) => {
                        return (
                          <>
                            <TableRow>
                              <TableCell
                                style={{
                                  fontSize: "0.95rem",
                                  fontWeight: "bold",
                                }}
                              >
                                {key}
                              </TableCell>
                              <TableCell
                                colSpan={8}
                                style={{
                                  fontSize: "0.95rem",
                                  fontWeight: "bold",
                                }}
                              >
                                {group.children[key].title}
                              </TableCell>
                            </TableRow>
                            {group.children[key].children.map(
                              (row: any, rowIndex: number) => {
                                return (
                                  <TableRow>
                                    <TableCell>{row.SNO}</TableCell>
                                    <TableCell>
                                      <div className="text-left">
                                        {row.param}
                                      </div>
                                    </TableCell>
                                    <TableCell>{row.uom}</TableCell>
                                    <TableCell>{row.target}</TableCell>
                                    <TableCell>{row.ytd}</TableCell>
                                    <TableCell>
                                      {" "}
                                      <FormControl fullWidth variant="standard">
                                        <Select
                                          value={row.dataSource}
                                          onChange={(e) =>
                                            handleChange(
                                              e,
                                              `health_children_${index}_children_${key}_children_${rowIndex}`,
                                              "dataSource"
                                            )
                                          }
                                        >
                                          <MenuItem value={"SAP"}>SAP</MenuItem>
                                          <MenuItem value={"Excel Logs"}>
                                            Excel Logs
                                          </MenuItem>
                                          <MenuItem value={"Regisers"}>
                                            Regisers
                                          </MenuItem>
                                          <MenuItem value={"Other"}>
                                            Other (Specify in comments)
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        backgroundColor:
                                          key != "B" ? "#FDF8E8" : "#F3F6FB",
                                      }}
                                    >
                                      {key != "B" ? (
                                        <Input
                                          onChange={(e) =>
                                            handleValueChange(
                                              e,
                                              `health_children_${index}_children_${key}_children_${rowIndex}`
                                            )
                                          }
                                          value={row.value}
                                        />
                                      ) : (
                                        <div>{row.value}</div>
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      <label
                                        htmlFor={`health_children_${index}_children_${key}_children_${rowIndex}`}
                                      >
                                        <Badge
                                          anchorOrigin={{
                                            vertical: "bottom",
                                            horizontal: "right",
                                          }}
                                          className={
                                            row.attachments.length
                                              ? "pw-badge-primary"
                                              : "pw-badge-disabled"
                                          }
                                          badgeContent={
                                            row.attachments.length || (
                                              <AddIcon />
                                            )
                                          }
                                        >
                                          <AttachFileIcon />
                                        </Badge>
                                      </label>
                                      <input
                                        type="file"
                                        id={`health_children_${index}_children_${key}_children_${rowIndex}`}
                                        className="hidden"
                                        onChange={(e) =>
                                          handleFileUpload(
                                            e,
                                            `health_children_${index}_children_${key}_children_${rowIndex}`
                                          )
                                        }
                                      />
                                    </TableCell>
                                    <TableCell>
                                      <Input
                                        value={row.comments}
                                        onChange={(e) =>
                                          handleChange(
                                            e,
                                            `health_children_${index}_children_${key}_children_${rowIndex}`,
                                            "comments"
                                          )
                                        }
                                      />
                                    </TableCell>
                                  </TableRow>
                                );
                              }
                            )}
                          </>
                        );
                      })}
                    </>
                  );
                })}
              </TableBody>
            </Table>
          </TabPanel>
          <TabPanel value="3">
            <Table sx={{ minWidth: 650 }} className="pw-data-table">
              <TableHead sx={{ backgroundColor: "#FAFBFD" }}>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Parameters</TableCell>
                  <TableCell>UOM</TableCell>
                  <TableCell>Target</TableCell>
                  <TableCell>YTD</TableCell>
                  <TableCell>Data source</TableCell>
                  <TableCell>Value</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Comments</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {formData.assurance.children.map(
                  (group: any, index: number) => {
                    return (
                      <>
                        {group.title ? (
                          <TableRow>
                            <TableCell style={{ fontSize: "1rem" }}>
                              <b>{index + 1}</b>
                            </TableCell>
                            <TableCell colSpan={8} style={{ fontSize: "1rem" }}>
                              <b>{group.title}</b>
                            </TableCell>
                          </TableRow>
                        ) : (
                          ""
                        )}
                        {Object.keys(group.children).map((key: string) => {
                          return (
                            <>
                              <TableRow>
                                <TableCell
                                  style={{
                                    fontSize: "0.95rem",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {key}
                                </TableCell>
                                <TableCell
                                  colSpan={8}
                                  style={{
                                    fontSize: "0.95rem",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {group.children[key].title}
                                </TableCell>
                              </TableRow>
                              {group.children[key].children.map(
                                (row: any, rowIndex: number) => {
                                  return (
                                    <TableRow>
                                      <TableCell>{row.SNO}</TableCell>
                                      <TableCell>{row.param}</TableCell>
                                      <TableCell>{row.uom}</TableCell>
                                      <TableCell>{row.target}</TableCell>
                                      <TableCell>{row.ytd}</TableCell>
                                      <TableCell>
                                        <FormControl
                                          fullWidth
                                          variant="standard"
                                        >
                                          <Select
                                            value={row.dataSource}
                                            onChange={(e) =>
                                              handleChange(
                                                e,
                                                `assurance_children_${index}_children_${key}_children_${rowIndex}`,
                                                "dataSource"
                                              )
                                            }
                                          >
                                            <MenuItem value={"SAP"}>
                                              SAP
                                            </MenuItem>
                                            <MenuItem value={"Excel Logs"}>
                                              Excel Logs
                                            </MenuItem>
                                            <MenuItem value={"Regisers"}>
                                              Regisers
                                            </MenuItem>
                                            <MenuItem value={"Other"}>
                                              Other (Specify in comments)
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </TableCell>
                                      <TableCell
                                        sx={{ backgroundColor: "#FDF8E8" }}
                                      >
                                        {" "}
                                        {row.boolean ? (
                                          <FormControl
                                            fullWidth
                                            variant="standard"
                                          >
                                            <Select
                                              value={row.value}
                                              onChange={(e) =>
                                                handleChange(
                                                  e,
                                                  `assurance_children_${index}_children_${key}_children_${rowIndex}`,
                                                  "value"
                                                )
                                              }
                                            >
                                              <MenuItem value={"Yes"}>
                                                Yes
                                              </MenuItem>
                                              <MenuItem value={"No"}>
                                                No
                                              </MenuItem>
                                            </Select>
                                          </FormControl>
                                        ) : (
                                          <Input
                                            onChange={(e) =>
                                              handleValueChange(
                                                e,
                                                `assurance_children_${index}_children_${key}_children_${rowIndex}`
                                              )
                                            }
                                          />
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        <label
                                          htmlFor={`assurance_children_${index}_children_${key}_children_${rowIndex}`}
                                        >
                                          <Badge
                                            anchorOrigin={{
                                              vertical: "bottom",
                                              horizontal: "right",
                                            }}
                                            className={
                                              row.attachments.length
                                                ? "pw-badge-primary"
                                                : "pw-badge-disabled"
                                            }
                                            badgeContent={
                                              row.attachments.length || (
                                                <AddIcon />
                                              )
                                            }
                                          >
                                            <AttachFileIcon />
                                          </Badge>
                                        </label>
                                        <input
                                          type="file"
                                          id={`assurance_children_${index}_children_${key}_children_${rowIndex}`}
                                          className="hidden"
                                          onChange={(e) =>
                                            handleFileUpload(
                                              e,
                                              `assurance_children_${index}_children_${key}_children_${rowIndex}`
                                            )
                                          }
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <Input
                                          value={row.comments}
                                          onChange={(e) =>
                                            handleChange(
                                              e,
                                              `assurance_children_${index}_children_${key}_children_${rowIndex}`,
                                              "comments"
                                            )
                                          }
                                        />
                                      </TableCell>
                                    </TableRow>
                                  );
                                }
                              )}
                            </>
                          );
                        })}
                      </>
                    );
                  }
                )}
              </TableBody>
            </Table>
          </TabPanel>
        </TabContext>
        <Box></Box>
      </Box>
      <div
        className="fixed bottom-0 bg-white p-4 flex justify-end"
        style={{ width: "-webkit-fill-available", zIndex: 1 }}
      >
        <Button
          variant="outlined"
          sx={{ color: "black", textTransform: "none", marginRight: "20px" }}
        >
          <b
            style={{
              paddingLeft: "10px",
              paddingRight: "10px",
              fontSize: "1rem",
            }}
            onClick={goToCustomerList}
          >
            Cancel
          </b>
        </Button>
        <Button
          variant="contained"
          sx={{ color: "white", textTransform: "none" }}
          color="primary"
          onClick={submitData}
        >
          <b
            style={{
              paddingLeft: "10px",
              paddingRight: "10px",
              fontSize: "1rem",
            }}
          >
            Submit
          </b>
        </Button>
      </div>
    </div>
  );
}
